import instance from 'utils/axios/instance.axios';
import { STATISTICS } from './_constant';

// eslint-disable-next-line import/prefer-default-export
export const getStatistic = () => instance.get(STATISTICS.GET);
export const getTotalKpiStatistics = () => instance.get(STATISTICS.GET_TOTAL_KPI);
export const getTotalExpenditureStatistics = (body = {}) =>
  instance.post(STATISTICS.GET_TOTAL_EXPENDITURE, body);
export const getDetailKpiStatistics = (body = {}) => instance.post(STATISTICS.GET_DETAIL_KPI, body);
export const getYears = () => instance.get(STATISTICS.GET_YEARS);
export const getAllUserStatistics = (body = {}) =>
  instance.post(STATISTICS.GET_ALL_USER_STATISTIC, body);

export const getCouncilsByUserId = (userId, pagination) => {
  const params = new URLSearchParams();

  // Add pagination params
  if (pagination) {
    if (pagination.first !== undefined) {
      params.append('first', pagination.first);
    }
    if (pagination.rowsPerPage !== undefined) {
      params.append('rowsPerPage', pagination.rowsPerPage);
    }
  }

  const url = params.toString()
    ? `${STATISTICS.GET_COUNCILS_BY_USER_ID(userId)}?${params.toString()}`
    : STATISTICS.GET_COUNCILS_BY_USER_ID(userId);

  return instance.get(url);
};
